<template>
  <div class="input-currency-wrapper" style="position: relative">
    <span class="prepend" v-if="prepend">{{ prepend }}</span>
    <input
      :disabled="disabled"
      type="text"
      :value="formattedValue"
      @input="onInput($event.target.value)"
      @blur="formatOnBlur"
      :placeholder="placeholder"
      @keydown="onKeydown"
      class="custom-number-input"
      :class="{ 'has-append': append }"
      :style="inputStyle"
      :required="required"
    />
    <span class="append" v-if="append">{{ append }}</span>
  </div>
</template>

<script>
export default {
  name: 'InputCurrency',
  props: {
    placeholder: null,
    disabled: Boolean,
    value: {
      type: [Number, String],
      default: 0,
    },
    prepend: {
      type: String,
      default: () => 'Rp',
    },
    append: {
      type: String,
      default: null,
    },
    required: Boolean,
  },
  computed: {
    formattedValue() {
      if (this.value === null || this.value === undefined || this.value === '')
        return ''
      return new Intl.NumberFormat('id-ID').format(this.value)
    },
    inputStyle() {
      let style = {}
      if (this.append) {
        // Calculate approximate width based on text length
        // Each character is roughly 8px, plus padding
        const appendWidth = (this.append.length * 8) + 16 + 14 // text + padding + margin
        style.paddingRight = `${Math.max(appendWidth, 54)}px`
      }
      if (this.prepend) {
        // Calculate approximate width based on text length
        // Each character is roughly 8px, plus padding
        const prependWidth = (this.prepend.length * 8) + 16 + 8 // text + padding + margin
        style.paddingLeft = `${Math.max(prependWidth, 48)}px`
      }
      return style
    }
  },
  methods: {
    onKeydown(e) {
      // Izinkan: angka, koma, titik, backspace, delete, panah, tab, enter
      if (
        !(
          (e.key >= '0' && e.key <= '9') ||
          e.key === '.' ||
          e.key === ',' ||
          e.key === 'Backspace' ||
          e.key === 'Delete' ||
          e.key === 'ArrowLeft' ||
          e.key === 'ArrowRight' ||
          e.key === 'Tab' ||
          e.key === 'Enter'
        )
      ) {
        e.preventDefault()
      }
    },
    onInput(val) {
      // Hapus semua karakter kecuali angka, koma, dan titik
      let clean = val.replace(/[^0-9.,]/g, '')
      // Hilangkan semua titik (pemisah ribuan)
      clean = clean.replace(/\./g, '')
      // Ganti koma jadi titik (untuk desimal)
      clean = clean.replace(',', '.')
      // Parse ke float
      let number = parseFloat(clean)
      if (isNaN(number)) number = null
      this.$emit('input', number)
    },
    onKeydown(e) {
      // Izinkan: angka, koma, titik, backspace, delete, panah, tab, enter
      if (
        !(
          (e.key >= '0' && e.key <= '9') ||
          e.key === '.' ||
          e.key === ',' ||
          e.key === 'Backspace' ||
          e.key === 'Delete' ||
          e.key === 'ArrowLeft' ||
          e.key === 'ArrowRight' ||
          e.key === 'Tab' ||
          e.key === 'Enter'
        )
      ) {
        e.preventDefault()
      }
    },
    formatOnBlur(e) {
      if (
        this.value !== null &&
        this.value !== undefined &&
        this.value !== ''
      ) {
        e.target.value = this.formattedValue
      }
    },
  },
}
</script>

<style scoped>
.custom-number-input {
  height: 35px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  text-align: right; /* biar rapih seperti input uang */
  width: 100%;
  color: #3f414d;
}
.custom-number-input.has-append {
  padding-right: 44px;
}
.custom-number-input:focus {
  border-color: #334697;
}
.input-currency-wrapper {
  display: flex;
  align-items: center;
}
.prepend {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
  color: #3f414d;
  font-size: 15px;
  background: #e9edf4;
  min-width: 40px;
  width: auto;
  padding: 0 8px;
  height: calc(100% - 1px);
  position: absolute;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  left: 0.5px;
  white-space: nowrap;
}
.append {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
  color: #3f414d;
  font-size: 15px;
  background: #e9edf4;
  min-width: 40px;
  width: auto;
  padding: 0 8px;
  height: calc(100% - 1px);
  position: absolute;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  right: 0.5px;
  white-space: nowrap;
}
</style>
